import { ReactNode } from 'react'

/**
 * StepFooter - Standardized footer component for install flow steps
 *
 * Provides a flexible container for action buttons
 *
 * All install flow steps should use this component in their footer
 * to ensure visual and behavioral consistency.
 */

export interface StepFooterProps {
  /**
   * List of action buttons to display
   * Each consumer passes their own styled buttons
   */
  actions: ReactNode[]
}

export function StepFooter({ actions }: StepFooterProps) {
  if (!actions || actions.length === 0) return null

  return (
    <div className="flex flex-col lg:flex-row gap-2 w-full">
      {actions.map((action, index) => (
        <div key={index} className="flex-1">
          {action}
        </div>
      ))}
    </div>
  )
}
